import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map, catchError } from 'rxjs';

export interface DocFile {
  name: string;
  path: string;
  title: string;
  description: string;
  category: string;
  content?: string;
  rawUrl?: string;
}

@Injectable({
  providedIn: 'root'
})
export class DocumentationService {
  // Usar archivos locales desde assets para evitar problemas de CORS
  private baseUrl = 'assets/docs';
  private githubUrl = 'https://github.com/juanss11/AutoComercialDelNorte/blob/main/AutoComercialDelNorte/docs';

  constructor(private http: HttpClient) { }

  getDocumentationFiles(): DocFile[] {
    return [
      {
        name: 'README.md',
        path: 'docs/README.md',
        title: 'Introducción General',
        description: 'Documentación general del proyecto AutoComercialDelNorte',
        category: 'General',
        rawUrl: `${this.baseUrl}/README.md`
      },
      {
        name: 'flujo-general.md',
        path: 'docs/flujo-general.md',
        title: 'Flujo General del Sistema',
        description: 'Descripción completa del flujo de trabajo del sistema',
        category: 'General',
        rawUrl: `${this.baseUrl}/flujo-general.md`
      },
      {
        name: 'estados-productos.md',
        path: 'docs/estados-productos.md',
        title: 'Estados de Productos',
        description: 'Definición y explicación de todos los estados de productos y repuestos',
        category: 'Estados',
        rawUrl: `${this.baseUrl}/estados-productos.md`
      },
      {
        name: '01-creacion-ordenes.md',
        path: 'docs/procesos/01-creacion-ordenes.md',
        title: 'Proceso 1: Creación de Órdenes',
        description: 'Proceso para crear nuevas órdenes de trabajo',
        category: 'Procesos',
        rawUrl: `${this.baseUrl}/procesos/01-creacion-ordenes.md`
      },
      {
        name: '02-embalaje-repuestos.md',
        path: 'docs/procesos/02-embalaje-repuestos.md',
        title: 'Proceso 2: Embalaje de Repuestos',
        description: 'Proceso para agrupar repuestos en paquetes',
        category: 'Procesos',
        rawUrl: `${this.baseUrl}/procesos/02-embalaje-repuestos.md`
      },
      {
        name: '03-carga-camion.md',
        path: 'docs/procesos/03-carga-camion.md',
        title: 'Proceso 3: Carga al Camión',
        description: 'Proceso para cargar paquetes al camión',
        category: 'Procesos',
        rawUrl: `${this.baseUrl}/procesos/03-carga-camion.md`
      },
      {
        name: '04-envio-taller.md',
        path: 'docs/procesos/04-envio-taller.md',
        title: 'Proceso 4: Envío al Taller',
        description: 'Proceso para enviar paquetes al taller de reparación',
        category: 'Procesos',
        rawUrl: `${this.baseUrl}/procesos/04-envio-taller.md`
      },
      {
        name: '05-recepcion-taller.md',
        path: 'docs/procesos/05-recepcion-taller.md',
        title: 'Proceso 5: Recepción en Taller',
        description: 'Proceso de recepción de paquetes en el taller',
        category: 'Procesos',
        rawUrl: `${this.baseUrl}/procesos/05-recepcion-taller.md`
      },
      {
        name: '06-desarmar-paquetes.md',
        path: 'docs/procesos/06-desarmar-paquetes.md',
        title: 'Proceso 6: Desarmar Paquetes',
        description: 'Proceso para desarmar paquetes y procesar repuestos',
        category: 'Procesos',
        rawUrl: `${this.baseUrl}/procesos/06-desarmar-paquetes.md`
      },
      {
        name: 'api-endpoints.md',
        path: 'docs/referencias/api-endpoints.md',
        title: 'API Endpoints',
        description: 'Referencia completa de todos los endpoints de la API',
        category: 'Referencias',
        rawUrl: `${this.baseUrl}/referencias/api-endpoints.md`
      },
      {
        name: 'estados-transiciones.md',
        path: 'docs/referencias/estados-transiciones.md',
        title: 'Estados y Transiciones',
        description: 'Diagrama de estados y transiciones del sistema',
        category: 'Referencias',
        rawUrl: `${this.baseUrl}/referencias/estados-transiciones.md`
      },
      {
        name: 'glosario.md',
        path: 'docs/referencias/glosario.md',
        title: 'Glosario de Términos',
        description: 'Definición de términos técnicos utilizados en el sistema',
        category: 'Referencias',
        rawUrl: `${this.baseUrl}/referencias/glosario.md`
      },
      {
        name: 'README-DOCUMENTATION-WEB.md',
        path: 'docs/README-DOCUMENTATION-WEB.md',
        title: 'Documentación Web',
        description: 'Información sobre la funcionalidad de documentación web',
        category: 'General',
        rawUrl: `${this.baseUrl}/README-DOCUMENTATION-WEB.md`
      }
    ];
  }

  getDocumentationContent(rawUrl: string): Observable<string> {
    return this.http.get(rawUrl, { responseType: 'text' }).pipe(
      catchError(error => {
        console.error('Error loading documentation:', error);
        return 'Error al cargar la documentación. Por favor, verifica tu conexión a internet.';
      })
    );
  }

  getGitHubUrl(file: DocFile): string {
    return this.githubUrl + file.path.replace('docs/', '/');
  }

  getCategories(): string[] {
    return ['General', 'Estados', 'Procesos', 'Referencias'];
  }

  getFilteredFiles(files: DocFile[], category: string): DocFile[] {
    if (category === 'all') {
      return files;
    }
    return files.filter(file => file.category === category);
  }

  getFilesByCategory(files: DocFile[], category: string): DocFile[] {
    return files.filter(file => file.category === category);
  }
}
